// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DiagramBuilder_MessageContentFragment } from '../../../artifactStudio/graphql/Diagram.generated';
import { gql } from '@apollo/client';
import { DiagramBuilder_MessageContentFragmentDoc } from '../../../artifactStudio/graphql/Diagram.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HouseholdChat_ApplicationRecordProvisionFragment = { __typename?: 'ApplicationRecordProvision', transferTaxKind: Types.DispositiveProvisionTransferTaxKind, dispositionOrder: number, transferMethod: Types.TransferMethod, bearsTax: boolean, notes?: string | null, recipient: { __typename?: 'ApplicationRecordProvisionRecipient', kind: Types.DispositiveProvisionRecipientKind, record?: { __typename?: 'ApplicationRecordReference', displayName: string } | null }, share: { __typename?: 'ApplicationRecordProvisionShare', kind: Types.DispositiveProvisionDispositionKind, percentage?: Percent | null, formulaicPercentage?: Percent | null, amountUSD?: CurrencyUSD | null, limitUSD?: CurrencyUSD | null, growByInflation: boolean } };

export type HouseholdChat_MessageFragment = { __typename?: 'Message', id: string, role: Types.MessageRole, content: string, type: Types.MessageType, withPromptTemplate?: Types.MessageWithPromptTemplate | null, status?: Types.MessageStatus | null, userUploadedImages: { __typename?: 'ImageConnection', edges?: Array<{ __typename?: 'ImageEdge', node?: { __typename?: 'Image', id: string } | null } | null> | null }, diagramArtifact?: { __typename?: 'DiagramArtifact', id: string, name: string } | null, diagramContent?: (
    { __typename?: 'DiagramMessageContent' }
    & DiagramBuilder_MessageContentFragment
  ) | null, confirmationContent?: { __typename?: 'ConfirmationMessageContent', title: string, details?: any | null, warnings: Array<{ __typename?: 'ApplicationRecordWarning', message: string }>, applicationRecordChanges?: { __typename?: 'ApplicationRecordChanges', people: Array<{ __typename?: 'ApplicationRecordPerson', name: string, isPrimary: boolean, relationships: Array<{ __typename?: 'ApplicationRecordPersonRelationship', relationship: Types.ClientProfileRelationshipType, person: { __typename?: 'ApplicationRecordReference', displayName: string } }> }>, organizations: Array<{ __typename?: 'ApplicationRecordOrganization', name: string, kind?: Types.ClientOrganizationKind | null }>, entities: Array<{ __typename?: 'ApplicationRecordEntity', name: string, kind: Types.EntityKind, isActivation: boolean, inEstate?: boolean | null, grantors: Array<{ __typename?: 'ApplicationRecordReference', displayName: string }>, accountOwners: Array<{ __typename?: 'ApplicationRecordReference', displayName: string }>, donors: Array<{ __typename?: 'ApplicationRecordReference', displayName: string }>, ownershipStakes: Array<{ __typename?: 'ApplicationRecordOwnershipStake', percentage: Percent, owner: { __typename?: 'ApplicationRecordReference', displayName: string } }> }>, testamentaryEntities: Array<{ __typename?: 'ApplicationRecordTestamentaryEntity', name: string, kind: Types.TestamentaryEntityKind, inEstate: boolean, createdFromEntities: Array<{ __typename?: 'ApplicationRecordReference', displayName: string }>, accountOwner?: { __typename?: 'ApplicationRecordReference', displayName: string } | null }>, assets: Array<{ __typename?: 'ApplicationRecordAsset', name: string, assetClass: string, valueUSD?: CurrencyUSD | null, previousValueUSD?: CurrencyUSD | null, valueChanged: boolean, owningEntity: { __typename?: 'ApplicationRecordReference', displayName: string } }>, lifeInsurancePolicies: Array<{ __typename?: 'ApplicationRecordLifeInsurancePolicy', carrierName?: string | null, kind: Types.InsurancePolicyKind, deathBenefitUSD: CurrencyUSD, cashValueUSD?: CurrencyUSD | null, startDate?: string | null, termDurationYears?: number | null, survivorship: boolean, owningEntity: { __typename?: 'ApplicationRecordReference', displayName: string }, insuredPeople: Array<{ __typename?: 'ApplicationRecordReference', displayName: string }> }>, liabilities: Array<{ __typename?: 'ApplicationRecordLiability', name: string, currentAmountUSD?: CurrencyUSD | null, amountAsOfDate?: string | null, borrower: { __typename?: 'ApplicationRecordReference', displayName: string }, lender?: { __typename?: 'ApplicationRecordReference', displayName: string } | null }>, dispositionScenarioGroups: Array<{ __typename?: 'ApplicationRecordDispositionScenarioProvisionGroup', deathEvent: Types.AiSuggestionDispositiveProvisionDeathEvent, fundedFrom: { __typename?: 'ApplicationRecordReference', displayName: string }, firstDeathClient: { __typename?: 'ApplicationRecordReference', displayName: string }, provisions: Array<(
          { __typename?: 'ApplicationRecordProvision' }
          & HouseholdChat_ApplicationRecordProvisionFragment
        )> }>, beneficiaryDesignationGroups: Array<{ __typename?: 'ApplicationRecordBeneficiaryDesignationProvisionGroup', tier: Types.BeneficiaryDesignationTier, account: { __typename?: 'ApplicationRecordReference', displayName: string }, provisions: Array<(
          { __typename?: 'ApplicationRecordProvision' }
          & HouseholdChat_ApplicationRecordProvisionFragment
        )> }> } | null } | null, freeFormQuestionContent?: { __typename?: 'FreeFormQuestionMessageContent', title: string, subtitle?: string | null } | null, groupedQuestionContent?: { __typename?: 'GroupedQuestionMessageContent', questions: Array<{ __typename?: 'GroupedQuestion', id: string, title: string, subtitle?: string | null }> } | null, multipleChoiceSingleSelectContent?: { __typename?: 'MultipleChoiceSingleSelectMessageContent', title: string, hideOtherOption: boolean, options: Array<{ __typename?: 'MessageResponseOption', label: string, value: string }> } | null, multipleChoiceMultiSelectContent?: { __typename?: 'MultipleChoiceMultiSelectMessageContent', title: string, hideOtherOption: boolean, options: Array<{ __typename?: 'MessageResponseOption', label: string, value: string }> } | null, responseFor: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', node?: { __typename?: 'Message', id: string, content: string, responseAction?: Types.MessageResponseAction | null, sender?: { __typename?: 'User', id: string, displayName: string } | null } | null } | null> | null } };

export type HouseholdChat_ConversationFragment = { __typename?: 'Conversation', id: string, kind?: Types.ConversationKind | null, mode?: Types.ChatMode | null, messages: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', node?: (
        { __typename?: 'Message' }
        & HouseholdChat_MessageFragment
      ) | null } | null> | null } };

export type StartHouseholdChatStreamMutationVariables = Types.Exact<{
  input: Types.HouseholdStartChatStreamInput;
}>;


export type StartHouseholdChatStreamMutation = { __typename?: 'Mutation', startHouseholdChatStream: { __typename?: 'HouseholdStartChatStreamPayload', conversation: (
      { __typename?: 'Conversation' }
      & HouseholdChat_ConversationFragment
    ) } };

export type SendHouseholdChatMessageMutationVariables = Types.Exact<{
  input: Types.HouseholdSendChatMessageInput;
}>;


export type SendHouseholdChatMessageMutation = { __typename?: 'Mutation', sendHouseholdChatMessage: { __typename?: 'HouseholdSendChatMessagePayload', workflowTracker: { __typename?: 'WorkflowTracker', id: string } } };

export type SubscribeHouseholdChatSubscriptionVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
}>;


export type SubscribeHouseholdChatSubscription = { __typename?: 'Subscription', subscribeHouseholdChat: { __typename?: 'HouseholdChatStreamEvent', workflowTrackerID?: string | null, textDelta?: string | null, activity?: { __typename?: 'HouseholdChatActivity', kind: Types.HouseholdChatActivityKind, label: string, toolName?: string | null } | null, message?: (
      { __typename?: 'Message' }
      & HouseholdChat_MessageFragment
    ) | null, result?: { __typename?: 'HouseholdChatResult', answer: string, conversation: (
        { __typename?: 'Conversation' }
        & HouseholdChat_ConversationFragment
      ) } | null } };

export type HouseholdChatPersonasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HouseholdChatPersonasQuery = { __typename?: 'Query', householdChatPersonas: Array<{ __typename?: 'HouseholdChatPersona', persona: Types.ChatPersona, displayName: string, subtitle: string, description: string, personaFeatures: Array<string> }> };

export type RespondToHouseholdChatMessageMutationVariables = Types.Exact<{
  input: Types.HouseholdRespondToChatMessageInput;
}>;


export type RespondToHouseholdChatMessageMutation = { __typename?: 'Mutation', respondToHouseholdChatMessage: { __typename?: 'HouseholdRespondToChatMessagePayload', messageID: string, responseAction: Types.MessageResponseAction, freeFormText?: string | null } };

export type HouseholdChat_ConversationListItemFragment = { __typename?: 'Conversation', id: string, updatedAt: Time, kind?: Types.ConversationKind | null, metadata?: { __typename?: 'ConversationMetadata', url?: string | null } | null, messages: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', node?: { __typename?: 'Message', id: string, content: string } | null } | null> | null } };

export type HouseholdChatConversationsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  conversationFilters: Array<Types.ConversationWhereInput> | Types.ConversationWhereInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type HouseholdChatConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationConnection', totalCount: number, edges?: Array<{ __typename?: 'ConversationEdge', cursor: any, node?: (
        { __typename?: 'Conversation' }
        & HouseholdChat_ConversationListItemFragment
      ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | null } } };

export type DeleteHouseholdChatConversationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteHouseholdChatConversationMutation = { __typename?: 'Mutation', deleteHouseholdChatConversation: string };

export type HouseholdChatConversationQueryVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
}>;


export type HouseholdChatConversationQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | (
    { __typename?: 'Conversation' }
    & HouseholdChat_ConversationFragment
  ) | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity' } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export const Operations = {
  Query: {
    HouseholdChatPersonas: 'HouseholdChatPersonas' as const,
    HouseholdChatConversations: 'HouseholdChatConversations' as const,
    HouseholdChatConversation: 'HouseholdChatConversation' as const
  },
  Mutation: {
    StartHouseholdChatStream: 'StartHouseholdChatStream' as const,
    SendHouseholdChatMessage: 'SendHouseholdChatMessage' as const,
    RespondToHouseholdChatMessage: 'RespondToHouseholdChatMessage' as const,
    DeleteHouseholdChatConversation: 'DeleteHouseholdChatConversation' as const
  },
  Subscription: {
    SubscribeHouseholdChat: 'SubscribeHouseholdChat' as const
  },
  Fragment: {
    HouseholdChat_ApplicationRecordProvision: 'HouseholdChat_ApplicationRecordProvision' as const,
    HouseholdChat_Message: 'HouseholdChat_Message' as const,
    HouseholdChat_Conversation: 'HouseholdChat_Conversation' as const,
    HouseholdChat_ConversationListItem: 'HouseholdChat_ConversationListItem' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HouseholdChat_ApplicationRecordProvisionFragmentDoc = gql`
    fragment HouseholdChat_ApplicationRecordProvision on ApplicationRecordProvision {
  recipient {
    kind
    record {
      displayName
    }
  }
  share {
    kind
    percentage
    formulaicPercentage
    amountUSD
    limitUSD
    growByInflation
  }
  transferTaxKind
  dispositionOrder
  transferMethod
  bearsTax
  notes
}
    `;
export const HouseholdChat_MessageFragmentDoc = gql`
    fragment HouseholdChat_Message on Message {
  id
  role
  content
  type
  withPromptTemplate
  userUploadedImages {
    edges {
      node {
        id
      }
    }
  }
  diagramArtifact {
    id
    name
  }
  diagramContent {
    ...DiagramBuilder_MessageContent
  }
  status
  confirmationContent {
    title
    details
    warnings {
      message
    }
    applicationRecordChanges {
      people {
        name
        isPrimary
        relationships {
          person {
            displayName
          }
          relationship
        }
      }
      organizations {
        name
        kind
      }
      entities {
        name
        kind
        isActivation
        inEstate
        grantors {
          displayName
        }
        accountOwners {
          displayName
        }
        donors {
          displayName
        }
        ownershipStakes {
          owner {
            displayName
          }
          percentage
        }
      }
      testamentaryEntities {
        name
        kind
        inEstate
        createdFromEntities {
          displayName
        }
        accountOwner {
          displayName
        }
      }
      assets {
        name
        owningEntity {
          displayName
        }
        assetClass
        valueUSD
        previousValueUSD
        valueChanged
      }
      lifeInsurancePolicies {
        carrierName
        kind
        owningEntity {
          displayName
        }
        insuredPeople {
          displayName
        }
        deathBenefitUSD
        cashValueUSD
        startDate
        termDurationYears
        survivorship
      }
      liabilities {
        name
        borrower {
          displayName
        }
        lender {
          displayName
        }
        currentAmountUSD
        amountAsOfDate
      }
      dispositionScenarioGroups {
        fundedFrom {
          displayName
        }
        deathEvent
        firstDeathClient {
          displayName
        }
        provisions {
          ...HouseholdChat_ApplicationRecordProvision
        }
      }
      beneficiaryDesignationGroups {
        account {
          displayName
        }
        tier
        provisions {
          ...HouseholdChat_ApplicationRecordProvision
        }
      }
    }
  }
  freeFormQuestionContent {
    title
    subtitle
  }
  groupedQuestionContent {
    questions {
      id
      title
      subtitle
    }
  }
  multipleChoiceSingleSelectContent {
    title
    hideOtherOption
    options {
      label
      value
    }
  }
  multipleChoiceMultiSelectContent {
    title
    hideOtherOption
    options {
      label
      value
    }
  }
  responseFor {
    edges {
      node {
        id
        content
        responseAction
        sender {
          id
          displayName
        }
      }
    }
  }
}
    ${DiagramBuilder_MessageContentFragmentDoc}
${HouseholdChat_ApplicationRecordProvisionFragmentDoc}`;
export const HouseholdChat_ConversationFragmentDoc = gql`
    fragment HouseholdChat_Conversation on Conversation {
  id
  kind
  mode
  messages(orderBy: [{field: created_at, direction: ASC}]) {
    edges {
      node {
        ...HouseholdChat_Message
      }
    }
  }
}
    ${HouseholdChat_MessageFragmentDoc}`;
export const HouseholdChat_ConversationListItemFragmentDoc = gql`
    fragment HouseholdChat_ConversationListItem on Conversation {
  id
  updatedAt
  kind
  metadata {
    url
  }
  messages(first: 1, orderBy: [{field: created_at, direction: ASC}]) {
    edges {
      node {
        id
        content
      }
    }
  }
}
    `;
export const StartHouseholdChatStreamDocument = gql`
    mutation StartHouseholdChatStream($input: HouseholdStartChatStreamInput!) {
  startHouseholdChatStream(input: $input) {
    conversation {
      ...HouseholdChat_Conversation
    }
  }
}
    ${HouseholdChat_ConversationFragmentDoc}`;
export type StartHouseholdChatStreamMutationFn = Apollo.MutationFunction<StartHouseholdChatStreamMutation, StartHouseholdChatStreamMutationVariables>;

/**
 * __useStartHouseholdChatStreamMutation__
 *
 * To run a mutation, you first call `useStartHouseholdChatStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartHouseholdChatStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startHouseholdChatStreamMutation, { data, loading, error }] = useStartHouseholdChatStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartHouseholdChatStreamMutation(baseOptions?: Apollo.MutationHookOptions<StartHouseholdChatStreamMutation, StartHouseholdChatStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartHouseholdChatStreamMutation, StartHouseholdChatStreamMutationVariables>(StartHouseholdChatStreamDocument, options);
      }
export type StartHouseholdChatStreamMutationHookResult = ReturnType<typeof useStartHouseholdChatStreamMutation>;
export type StartHouseholdChatStreamMutationResult = Apollo.MutationResult<StartHouseholdChatStreamMutation>;
export type StartHouseholdChatStreamMutationOptions = Apollo.BaseMutationOptions<StartHouseholdChatStreamMutation, StartHouseholdChatStreamMutationVariables>;
export const SendHouseholdChatMessageDocument = gql`
    mutation SendHouseholdChatMessage($input: HouseholdSendChatMessageInput!) {
  sendHouseholdChatMessage(input: $input) {
    workflowTracker {
      id
    }
  }
}
    `;
export type SendHouseholdChatMessageMutationFn = Apollo.MutationFunction<SendHouseholdChatMessageMutation, SendHouseholdChatMessageMutationVariables>;

/**
 * __useSendHouseholdChatMessageMutation__
 *
 * To run a mutation, you first call `useSendHouseholdChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHouseholdChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHouseholdChatMessageMutation, { data, loading, error }] = useSendHouseholdChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendHouseholdChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendHouseholdChatMessageMutation, SendHouseholdChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendHouseholdChatMessageMutation, SendHouseholdChatMessageMutationVariables>(SendHouseholdChatMessageDocument, options);
      }
export type SendHouseholdChatMessageMutationHookResult = ReturnType<typeof useSendHouseholdChatMessageMutation>;
export type SendHouseholdChatMessageMutationResult = Apollo.MutationResult<SendHouseholdChatMessageMutation>;
export type SendHouseholdChatMessageMutationOptions = Apollo.BaseMutationOptions<SendHouseholdChatMessageMutation, SendHouseholdChatMessageMutationVariables>;
export const SubscribeHouseholdChatDocument = gql`
    subscription SubscribeHouseholdChat($conversationId: ID!) {
  subscribeHouseholdChat(conversationId: $conversationId) {
    workflowTrackerID
    activity {
      kind
      label
      toolName
    }
    textDelta
    message {
      ...HouseholdChat_Message
    }
    result {
      answer
      conversation {
        ...HouseholdChat_Conversation
      }
    }
  }
}
    ${HouseholdChat_MessageFragmentDoc}
${HouseholdChat_ConversationFragmentDoc}`;

/**
 * __useSubscribeHouseholdChatSubscription__
 *
 * To run a query within a React component, call `useSubscribeHouseholdChatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeHouseholdChatSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeHouseholdChatSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSubscribeHouseholdChatSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeHouseholdChatSubscription, SubscribeHouseholdChatSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeHouseholdChatSubscription, SubscribeHouseholdChatSubscriptionVariables>(SubscribeHouseholdChatDocument, withSubscriptionIgnoreResults(options));
      }
export type SubscribeHouseholdChatSubscriptionHookResult = ReturnType<typeof useSubscribeHouseholdChatSubscription>;
export type SubscribeHouseholdChatSubscriptionResult = Apollo.SubscriptionResult<SubscribeHouseholdChatSubscription>;
export const HouseholdChatPersonasDocument = gql`
    query HouseholdChatPersonas {
  householdChatPersonas {
    persona
    displayName
    subtitle
    description
    personaFeatures
  }
}
    `;

/**
 * __useHouseholdChatPersonasQuery__
 *
 * To run a query within a React component, call `useHouseholdChatPersonasQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdChatPersonasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdChatPersonasQuery({
 *   variables: {
 *   },
 * });
 */
export function useHouseholdChatPersonasQuery(baseOptions?: Apollo.QueryHookOptions<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>(HouseholdChatPersonasDocument, withFetchPolicyContext(options));
      }
export function useHouseholdChatPersonasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>(HouseholdChatPersonasDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHouseholdChatPersonasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>(HouseholdChatPersonasDocument, withFetchPolicyContext(options));
        }
export type HouseholdChatPersonasQueryHookResult = ReturnType<typeof useHouseholdChatPersonasQuery>;
export type HouseholdChatPersonasLazyQueryHookResult = ReturnType<typeof useHouseholdChatPersonasLazyQuery>;
export type HouseholdChatPersonasSuspenseQueryHookResult = ReturnType<typeof useHouseholdChatPersonasSuspenseQuery>;
export type HouseholdChatPersonasQueryResult = Apollo.QueryResult<HouseholdChatPersonasQuery, HouseholdChatPersonasQueryVariables>;
export const RespondToHouseholdChatMessageDocument = gql`
    mutation RespondToHouseholdChatMessage($input: HouseholdRespondToChatMessageInput!) {
  respondToHouseholdChatMessage(input: $input) {
    messageID
    responseAction
    freeFormText
  }
}
    `;
export type RespondToHouseholdChatMessageMutationFn = Apollo.MutationFunction<RespondToHouseholdChatMessageMutation, RespondToHouseholdChatMessageMutationVariables>;

/**
 * __useRespondToHouseholdChatMessageMutation__
 *
 * To run a mutation, you first call `useRespondToHouseholdChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToHouseholdChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToHouseholdChatMessageMutation, { data, loading, error }] = useRespondToHouseholdChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToHouseholdChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<RespondToHouseholdChatMessageMutation, RespondToHouseholdChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToHouseholdChatMessageMutation, RespondToHouseholdChatMessageMutationVariables>(RespondToHouseholdChatMessageDocument, options);
      }
export type RespondToHouseholdChatMessageMutationHookResult = ReturnType<typeof useRespondToHouseholdChatMessageMutation>;
export type RespondToHouseholdChatMessageMutationResult = Apollo.MutationResult<RespondToHouseholdChatMessageMutation>;
export type RespondToHouseholdChatMessageMutationOptions = Apollo.BaseMutationOptions<RespondToHouseholdChatMessageMutation, RespondToHouseholdChatMessageMutationVariables>;
export const HouseholdChatConversationsDocument = gql`
    query HouseholdChatConversations($householdId: ID!, $conversationFilters: [ConversationWhereInput!]!, $first: Int!, $after: Cursor) {
  conversations(
    first: $first
    after: $after
    orderBy: [{field: updated_at, direction: DESC}]
    where: {householdID: $householdId, or: $conversationFilters}
  ) {
    edges {
      node {
        ...HouseholdChat_ConversationListItem
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${HouseholdChat_ConversationListItemFragmentDoc}`;

/**
 * __useHouseholdChatConversationsQuery__
 *
 * To run a query within a React component, call `useHouseholdChatConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdChatConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdChatConversationsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      conversationFilters: // value for 'conversationFilters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useHouseholdChatConversationsQuery(baseOptions: Apollo.QueryHookOptions<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>(HouseholdChatConversationsDocument, withFetchPolicyContext(options));
      }
export function useHouseholdChatConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>(HouseholdChatConversationsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHouseholdChatConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>(HouseholdChatConversationsDocument, withFetchPolicyContext(options));
        }
export type HouseholdChatConversationsQueryHookResult = ReturnType<typeof useHouseholdChatConversationsQuery>;
export type HouseholdChatConversationsLazyQueryHookResult = ReturnType<typeof useHouseholdChatConversationsLazyQuery>;
export type HouseholdChatConversationsSuspenseQueryHookResult = ReturnType<typeof useHouseholdChatConversationsSuspenseQuery>;
export type HouseholdChatConversationsQueryResult = Apollo.QueryResult<HouseholdChatConversationsQuery, HouseholdChatConversationsQueryVariables>;
export const DeleteHouseholdChatConversationDocument = gql`
    mutation DeleteHouseholdChatConversation($id: ID!) {
  deleteHouseholdChatConversation(id: $id)
}
    `;
export type DeleteHouseholdChatConversationMutationFn = Apollo.MutationFunction<DeleteHouseholdChatConversationMutation, DeleteHouseholdChatConversationMutationVariables>;

/**
 * __useDeleteHouseholdChatConversationMutation__
 *
 * To run a mutation, you first call `useDeleteHouseholdChatConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHouseholdChatConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHouseholdChatConversationMutation, { data, loading, error }] = useDeleteHouseholdChatConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHouseholdChatConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHouseholdChatConversationMutation, DeleteHouseholdChatConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHouseholdChatConversationMutation, DeleteHouseholdChatConversationMutationVariables>(DeleteHouseholdChatConversationDocument, options);
      }
export type DeleteHouseholdChatConversationMutationHookResult = ReturnType<typeof useDeleteHouseholdChatConversationMutation>;
export type DeleteHouseholdChatConversationMutationResult = Apollo.MutationResult<DeleteHouseholdChatConversationMutation>;
export type DeleteHouseholdChatConversationMutationOptions = Apollo.BaseMutationOptions<DeleteHouseholdChatConversationMutation, DeleteHouseholdChatConversationMutationVariables>;
export const HouseholdChatConversationDocument = gql`
    query HouseholdChatConversation($conversationId: ID!) {
  node(id: $conversationId) {
    ... on Conversation {
      ...HouseholdChat_Conversation
    }
  }
}
    ${HouseholdChat_ConversationFragmentDoc}`;

/**
 * __useHouseholdChatConversationQuery__
 *
 * To run a query within a React component, call `useHouseholdChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdChatConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useHouseholdChatConversationQuery(baseOptions: Apollo.QueryHookOptions<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>(HouseholdChatConversationDocument, withFetchPolicyContext(options));
      }
export function useHouseholdChatConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>(HouseholdChatConversationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHouseholdChatConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>(HouseholdChatConversationDocument, withFetchPolicyContext(options));
        }
export type HouseholdChatConversationQueryHookResult = ReturnType<typeof useHouseholdChatConversationQuery>;
export type HouseholdChatConversationLazyQueryHookResult = ReturnType<typeof useHouseholdChatConversationLazyQuery>;
export type HouseholdChatConversationSuspenseQueryHookResult = ReturnType<typeof useHouseholdChatConversationSuspenseQuery>;
export type HouseholdChatConversationQueryResult = Apollo.QueryResult<HouseholdChatConversationQuery, HouseholdChatConversationQueryVariables>;